import {Injectable} from '@angular/core';
import {Inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {IAppConfig} from '../app-config.interface';
import {APP_CONFIG} from '../app-config.constants';
import {environment} from '../../environments/environment-wrapper';
import {ObjectResponse} from '../classes/object-response';
import {HttpParams} from '@angular/common/http';

@Injectable()
export class HomeEstimatorService {
  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig,
              private httpClient: HttpClient) {
  }

  getHomeEstimate(estimateProperty: Property): Promise<ObjectResponse<HomeEstimatorResponse>> {
    let params = new HttpParams();
    if (estimateProperty.assessmentArea_Code) params = params.set('assessmentArea_Code', estimateProperty.assessmentArea_Code);
    if (estimateProperty.jurisdiction_Descp) params = params.set('jurisdiction_Descp', estimateProperty.jurisdiction_Descp);
    if (estimateProperty.jurisdiction_Code) params = params.set('jurisdiction_Code', estimateProperty.jurisdiction_Code);
    if (estimateProperty.roll_Number) params = params.set('roll_Number', estimateProperty.roll_Number);
    if (estimateProperty.apart_Suite) params = params.set('apart_Suite', estimateProperty.apart_Suite);
    if (estimateProperty.street_From) params = params.set('street_From', estimateProperty.street_From);
    if (estimateProperty.street_Name) params = params.set('street_Name', estimateProperty.street_Name);
    if (estimateProperty.street_Dir) params = params.set('street_Dir', estimateProperty.street_Dir);
    if (estimateProperty.postal_Code) params = params.set('postal_Code', estimateProperty.postal_Code);
    if (estimateProperty.property_Type) params = params.set('property_Type', estimateProperty.property_Type);
    return this.httpClient.get<ObjectResponse<HomeEstimatorResponse>>(environment.baseServerUrl + this.appConfig.urls.homeEstimator.estimate, {params}).toPromise();
  }

  getSuggestions(homeEstimatorRequest: HomeEstimatorRequest): Promise<ObjectResponse<Property[]>> {
    let params = new HttpParams();
    if (homeEstimatorRequest.streetName) params = params.set('streetName', homeEstimatorRequest.streetName);
    if (homeEstimatorRequest.streetNumber) params = params.set('streetNumber', homeEstimatorRequest.streetNumber);
    if (homeEstimatorRequest.unitNumber) params = params.set('unitNumber', homeEstimatorRequest.unitNumber);
    if (homeEstimatorRequest.streetDirection) params = params.set('streetDirection', homeEstimatorRequest.streetDirection);
    if (homeEstimatorRequest.location) params = params.set('location', homeEstimatorRequest.location);
    return this.httpClient.get<ObjectResponse<Property[]>>(environment.baseServerUrl + this.appConfig.urls.homeEstimator.suggestions, {params}).toPromise();
  }
}

export class HomeEstimatorRequest {
  unitNumber: string;
  streetNumber: string;
  streetDirection: string;
  streetName: string;
  location: string;
}

export class HomeEstimateRequest {
  assessmentAreaCode: string;
  jurisdictionCode: string;
  rollNumber: string;
}

export interface Property {
  assessmentArea_Code: string,
  jurisdiction_Code: string,
  neighbourhood_Code: string,
  roll_Number: string,
  assessmentArea_Descp: string,
  jurisdiction_Descp: string,
  neighbourhood_Descp: string,
  apart_Suite: string,
  street_From: string,
  street_Name: string,
  street_Dir: string,
  postal_Code: string,
  property_Type: string
}

export interface HomeEstimatorResponse {
  actualUseTypeCode: number;
  lastTotalValueAmount: number;
  marketShiftAmount: number;
  marketValue: number;
  activeListingDetailUrl: string;
}
